import { Component, Prop, Watch } from 'vue-property-decorator';
import videojs, { VideoJsPlayer } from 'video.js';
import EditorBase from '../EditorBase';
import EditorApi from '@/apis/editor-api';
import { EComponentType } from '@/helpers/editor';

@Component({})
export default class PreviewSourceVideo extends EditorBase {
  $refs!: {
    previewVideoElement: HTMLVideoElement;
  };

  player: VideoJsPlayer = null;

  videoIsPlaying: boolean = false;
  errorRetries: number = 0;

  get hasGameCaptureComponent(): boolean {
    return this.components && this.components.some((component) => {
      return component.type === EComponentType.gameCapture;
    });
  }

  get refName(): string {
    return 'previewVideoElement';
  }

  get src(): string {
    return `${this.previewBaseUrl}/preview/${this.currentUser.stream_key}.m3u8`;
  }

  get width() {
    return this.projectWidth;
  }

  mounted() {
    this.player = videojs(
      this.refName,
      {
        muted: true
      });

    if (this.isLive || this.isStreamPreview) {
      this.play();
    }
  }

  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }

  @Watch('isStreamPreview')
  @Watch('isLive')
  togglePreviewVideo() {
    if (this.isLive || this.isStreamPreview) {
      this.play();
    } else if (!this.isLive && this.videoIsPlaying) {
      this.stop();
    }
  }

  async checkPreview() {
    const response = await EditorApi.checkPreview(`${this.previewBaseUrl}/api/v1/preview/${this.currentUser.stream_key}`);

    return response?.previewAvailable;
  }

  async requestPreview(retries: number) {
    const response = await EditorApi.requestPreview(`${this.previewBaseUrl}/api/v1/preview/${this.currentUser.stream_key}`);

    if ((this.isLive || this.isStreamPreview) && response && response.success && retries < 100) {
      setTimeout(() => {
        this.play(++retries);
      }, 3000 * retries);
    }
  }

  async play(retries: number = 0) {
    const previewAvailable = await this.checkPreview();
    if (!previewAvailable) {
      await this.requestPreview(retries);
      return;
    }

    this.player.tech().on('retryplaylist', (error) => {
      this.errorRetries++;
      if (this.isLive && this.videoIsPlaying) {
        this.videoIsPlaying = false;
        this.player.pause();
        setTimeout(() => {
          this.play();
        }, 7000);
      } else if (this.errorRetries > 10) {
        this.player.pause();
      }
    });

    this.player.src({
      src: this.src,
      type: 'application/x-mpegURL'
    });

    this.player.play().then(() => {
      this.videoIsPlaying = true;
      this.errorRetries = 0;
    }).catch(err => { });
  }

  stop() {
    this.player.pause();
    this.videoIsPlaying = false;
  }
}
